<template>
    <v-row>
        <v-col cols="2"></v-col>
        <v-col cols="8">
            
            Número do pedido: {{order.number}}<br/>
            Data: {{order.date}}<br/>
            Status: {{order.status}}<br/>                
            Itens <br/>
            <v-card-text v-for="product in order.products" v-bind:item="product" v-bind:key="product.id">
                Nome: {{product.title}} <br/>
                Valor: {{product.price}} <br/>
            </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        order: {
            type: Object,
            required: true
        }
    },    
}
</script>
